import $ from 'jquery';

require('./checkout.scss');

import { createRoot } from 'react-dom/client';
import React, {Suspense, useState, useEffect, useRef, useCallback} from 'react';
import ErrorSummary from "./ErrorSummary";
import TypePromo from "../components/TypePromo";
import Summary from "../components/Summary";
import useIsMobile from "./checkout/useIsMobile";
import {mapObjectToArray} from '../helpers';
import Select from './checkout/components/Select';
import OrderIndex from "../order-index";
import cloneDeep from 'lodash/cloneDeep';
import InvoicesList from "./checkout/components/InvoicesList";
import OrderReturn from "./checkout/components/OrderReturn";


function Loading() {
    return <div className="lds-ring">
        <div/>
        <div/>
        <div/>
        <div/>
    </div>
}

$.fn.autocomplete = function (options) {
    options = options || {};

    let source = options.source;
    let input = $(this);
    let data = [];
    let initialValue = input.val();

    if (input.hasClass('ac-input')) {
        return;
    }

    input.addClass('ac-input');

    let dd = $("<ul class='ac-dropdown'></ul>");

    let wrapper = $('<div class="ac-wrap"></div>');
    wrapper.append(dd);
    input.after(wrapper);
    wrapper.prepend(input);
    dd.hide();

    let renderData = () => {
        dd.html('');

        for (let index in data) {
            let one = data[index];
            let li = $("<li>" + one.name + "</li>");
            li.on('click', () => {
                input.val(one.name);
                initialValue = one.name;

                $(this).trigger('selected', one);
            });
            dd.append(li);
        }
    };

    input.on('keyup', function () {
        let setData = (newData) => {
            data = newData;
            renderData();
        };

        let query = $(this).val();
        source(query, setData);
    });

    function activate() {
        wrapper.addClass('active');
        dd.show();
    }

    function deactivate() {
        setTimeout(() => {
            wrapper.removeClass('active');
            dd.hide();
            input.val(initialValue);
        }, 200);
    }

    input.on('focus', function () {
        activate();
    });

    input.on('blur', function () {
        deactivate();
    });

    renderData();

    return $(this);
};

let tm = {};

let pages = {
    'common': React.lazy(() => import("./checkout/CommonPage")),
    'delivery': React.lazy(() => import("./checkout/DeliveryPage")),
    'check': React.lazy(() => import("./checkout/CheckPage"))
};

function UnknownPage() {
    return <div>Unknown module</div>
}

function SlidePanel(props) {
    let {slide} = props;

    let listenerRef = useRef(null);
    let divRef = useRef(null);
    let [className, setClassName] = useState('');
    let [styles, setStyles] = useState({});

    useEffect(() => {
        if (slide) {
            document.removeEventListener('scroll', listenerRef.current);

            listenerRef.current = () => {
                let divHolder = divRef.current.parentElement;
                // console.log('div offset top', divRef.current.offsetTop);
                // console.log('windowTop', window.scrollY);

                if (window.scrollY > divHolder.offsetTop) {
                    setStyles({'top': window.scrollY - divHolder.offsetTop})
                } else {
                    setStyles({})
                }
            }

            document.addEventListener('scroll', listenerRef.current);
        }

    }, [divRef.current])

    return <div style={styles} className={'order-right-slider ' + className} ref={divRef}>
        {props.children}
    </div>
}

function IfCond(props) {
    if (!props.condition) {
        return null;
    }

    return <>{props.children}</>
}

let orderShippingStatuses = [];
if (window.shippingStatusNames) { // for admin only
    orderShippingStatuses = mapObjectToArray(window.shippingStatusNames, (id, name) => ({
        id: parseInt(id),
        name
    }));
}

let invoiceStatuses = [];
if (window.shippingStatusNames) { // for admin only
    invoiceStatuses = mapObjectToArray(window.invoiceStatuses, (id, name) => ({
        id: parseInt(id),
        name
    }));
}


function AdditionalShippings(props) {
    let {
        updateShipping,
        model,
        updateField
    } = props;

    // console.log('ADDITIONAL MODEL', model);

    return <div style={{borderBottom: '2px solid black'}}>
        <div>
            <div className="form-group">
                <label>Дополнительная скидка</label>
                <input
                    value={model.discount_manual}
                    onChange={d => {
                        updateField('discount_manual', d.target.value)
                    }}
                />
            </div>
        </div>
        <div>
            shippings:

            {
                model.shippings.map((shipping, index) => <div key={shipping.id}>
                    <h3>{shipping.additionalName}</h3>
                    <div className="form-group">
                        <label>Статус</label>
                        <Select
                            value={shipping.status}
                            onChange={d => {
                                updateShipping(shipping, 'status', d)
                            }}
                            options={orderShippingStatuses}
                        />
                    </div>
                    <div className="form-group">
                        <label>Track number</label>
                        <input
                            value={shipping.track_number || ''}
                            onChange={e => {
                                updateShipping(shipping, 'track_number', e.target.value)
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label>Track url</label>
                        <input
                            value={shipping.track_url || ''}
                            onChange={e => {
                                updateShipping(shipping, 'track_url', e.target.value)
                            }}
                        />
                    </div>
                </div>)
            }
        </div>

    </div>
}


function CheckoutApp(props) {
    let {full, nextUrl, orderId, nextText, page} = props;
    let _nextText = nextText || 'Далее';

    let [model, setModel] = useState(null);
    let [errors, setErrors] = useState({});
    let isMobile = useIsMobile();
    const [fullPriceOI, setfullPriceOI] = useState()

    let nextPage = e => {
        e.preventDefault();
        e.stopPropagation();

        window.llg('checkout_click_next');

        if (full) {
            return;
        }

        setErrors(false);

        $.post(window.location.href, (data) => {

            if (data.success) {
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
            }

            if (data.errors) {
                setErrors(data.errors);

                setTimeout(() => {

                    let errorItem = document.querySelector('.form-error');

                    if (errorItem) {
                        errorItem.scrollIntoView(true);
                    }

                }, 0);
            }
        });
    }

    /**
     * Даты и временные интервалы
     */
    let reloadShipping = useCallback((shipping) => {
        console.info('RELOAD SHIPPING', shipping.id)

        setTimeout(() => {
            $.get('/order-api/get-data-shipping', {
                id: shipping.id,
                order_id: orderId,
            }, (data) => {
                let newModel = cloneDeep(model);
                let shInArr = newModel.shippings.find(s => s.id === shipping.id);
                let index = newModel.shippings.indexOf(shInArr);
                newModel.shippings[index] = data;

                window.cModel = newModel;

                loadOrderData();
            })
        }, 0)
    });

    /**
     * Common data loading function
     */
    function loadOrderData() {
        $.get('/order-api/get-data', {
            order_id: orderId
        }, (info) => {
            setModel(info);
            let fullPrice = 0;
            info.orderItems.map((item) => {
                fullPrice += item.originPrice * item.count
            })

            setfullPriceOI(fullPrice);
        })
    }

    let reloadOrderData = useCallback(loadOrderData);

    // set global updater for other widgets (for admin order-index for example)
    window.checkout__reloadData = loadOrderData;

    // first loading
    useEffect(() => {
        loadOrderData();
    }, [])

    // app loader
    let loading = <div className="wrap">
        <Loading/>
    </div>;

    // return loader
    if (model === null) {
        return loading;
    }

    // update model field without call api
    let upField = (field, value) => {
        let newModel = {...model};
        newModel[field] = value;
        setModel(newModel);
    }

    // API call for updating model
    function updateField(field, value, callback) {
        clearTimeout(tm[field]);
        let newModel = {...model};
        newModel[field] = value;
        setModel(newModel);

        tm[field] = setTimeout(() => {
            window.llg('checkout_update_field', {field, value})
            $.get('/order-api/update-field', {
                field,
                value,
                order_id: orderId,
            }, () => {
                window.toastr.success('обновлено');

                if (['discount_manual'].indexOf(field) !== -1) {
                    loadOrderData();
                }

                if (callback)
                    callback();
            });
        }, 500);
    }

    // update shipping field
    function updateShipping(shipping, field, value, callback) {

        window.llg('checkout_update_shipping_field', {id: shipping.id, field, value});

        // allow change fields if canEdit set to false (depends of current status of shipping)
        let allowFields = [
            'status',
            'track_number',
            'track_url',
        ];

        // check can change field
        if (!shipping.canEdit && allowFields.indexOf(field) === -1) {
            return;
        }

        // Try to change field to the same value. Do nothing
        let oldValue = shipping[field];
        if (oldValue === value) {
            return;
        }

        let shippingIndex = model.shippings.indexOf(shipping);
        let newModel = cloneDeep(model);

        if (shippingIndex === -1) {
            console.error('Sorry, can not find shipping index:', shipping)
            return;
        }

        newModel.shippings[shippingIndex][field] = value;

        if (field === 'delivery_type') {
            newModel.shippings[shippingIndex]['payment_type'] = null;
            newModel.shippings[shippingIndex]['delivery_time'] = null;
            newModel.shippings[shippingIndex]['delivery_date'] = null;
        }

        if (field === 'delivery_date') {
            newModel.shippings[shippingIndex]['delivery_time'] = null;
        }

        if (field === 'guru_city_id') { // reset pvz id also
            newModel.shippings[shippingIndex]['guru_pvz_id'] = null;
        }

        if (field === 'boxberry_city_id') { // reset pvz id also
            newModel.shippings[shippingIndex]['boxberry_pvz_id'] = null;
        }

        setModel(newModel);

        setTimeout(() => {
            if (field === 'delivery_type') { // api call
                $.get('/order-api/set-delivery-type', {
                    shipping_id: shipping.id,
                    delivery_type: value,
                    order_id: orderId,
                }, () => {
                    reloadShipping(shipping)
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            if (field == 'cdek_pvz') {
                
                    loadOrderData(); // we must reload shipping cost
                    // reloadShipping(shipping);
            }
            if (field === 'delivery_address_id_not_copy') { // api call
                newModel.shippings[shippingIndex]['delivery_date'] = null;
                newModel.shippings[shippingIndex]['delivery_time'] = null;
                newModel.shippings[shippingIndex]['payment_type'] = null;

                $.get('/order-api/set-address-id', {
                    shipping_id: shipping.id,
                    delivery_address_id: value,
                    order_id: orderId,
                }, () => {
                    loadOrderData(); // we must reload shipping cost
                    // reloadShipping(shipping);
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            if (field === 'payment_type') { // api call
                $.get('/order-api/set-payment-type', {
                    shipping_id: shipping.id,
                    payment_type: value,
                    order_id: orderId,
                }, () => {
                    reloadShipping(shipping)
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            // update other fields
            if (['delivery_date', 'delivery_time'].indexOf(field) !== -1) {
                $.get('/order-api/api-set-shipping-field', {
                    field,
                    value,
                    shipping_id: shipping.id,
                    order_id: orderId,
                }, () => {
                    reloadShipping(shipping)
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            if (['guru_city_id', 'guru_pvz_id'].indexOf(field) !== -1) {
                $.get('/order-api/api-set-guru-field', {
                    field,
                    value,
                    shipping_id: shipping.id,
                    order_id: orderId,
                }, () => {
                    reloadShipping(shipping)
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            if (['boxberry_city_id', 'boxberry_pvz_id'].indexOf(field) !== -1) {
                $.get('/order-api/api-set-boxberry-field', {
                    field,
                    value,
                    shipping_id: shipping.id,
                    order_id: orderId,
                }, () => {
                    reloadShipping(shipping)
                }).fail(() => {
                    alert('Возникла ошибка на сервере');
                })
            }

            // for admins only
            if (['status', 'track_number', 'track_url'].indexOf(field) !== -1) {
                clearTimeout(tm[field]);
                tm[field] = setTimeout(() => {
                    $.get('/order-api/api-set-shipping-field', {
                        field,
                        value,
                        shipping_id: shipping.id,
                        order_id: orderId,
                    }, () => {
                        reloadShipping(shipping)
                    }).fail(() => {
                        alert('Возникла ошибка на сервере');
                    })
                }, 500);
            }
        }, 300);
    }

    let hasDropshipping = model.hasDropshipping ? <div>
        <div className="title-sub">
            В вашей корзине есть товары, которые находятся на зарубежном складе. Поэтому ваш заказ
            разделится на 2
            посылки.
        </div>
        <hr/>
    </div> : null;

    let newProps = {
        ...props,
        updateField,
        model,
        updateShipping,
        hasDropshipping,
        errors,
        full,
        loadOrderData: reloadOrderData,
        upField,
    };

    let Component = pages[page] || UnknownPage;
    let renderComponent;

    let checkoutIndex = null;
    let invoiceList = null;
    let orderReturn = null;

    if (full) { // FULL MODE
        renderComponent = [];

        for (let i in pages) {
            if (i === 'check') continue;
            if (pages.hasOwnProperty(i)) {
                let personalProps = {...newProps};
                let Comp = pages[i];
                renderComponent.push(<Comp key={i} {...personalProps}/>)
            }
        }

        checkoutIndex = <OrderIndex
            {...newProps}
            enableButtons={0}
            leftInStock={1}
            canAddProducts={1}
            modelExternal={model}
            updateExternal={loadOrderData}
        />

        invoiceList = <InvoicesList {...newProps} invoiceStatuses={invoiceStatuses}/>
        orderReturn = <OrderReturn {...newProps} invoiceStatuses={invoiceStatuses}/>
    } else { // PROD MODE only single page
        renderComponent = <Component {...newProps}/>
    }

    return <Suspense fallback={loading}>
        <div className="wrap">
            <div className="">

                {full ? <h1>Заказ - {model.invoiceNumber}</h1> : null}

                {invoiceList}
                {orderReturn}
                {checkoutIndex}

                <div className="checkout2__content">
                    <div className="checkout2__split">
                        <div>
                            <ErrorSummary errors={errors}/>
                            {renderComponent}
                        </div>

                        <div>
                            <SlidePanel slide={!full}>
                                <IfCond condition={full}>
                                    <AdditionalShippings {...newProps}/>
                                </IfCond>

                                <IfCond condition={!isMobile || page === 'check'}>
                                    <Summary model={model} fullPriceOI={fullPriceOI}/>

                                    <TypePromo
                                        value={model.promocode}
                                        onChange={(promo) => upField('promocode', promo)}
                                        orderId={orderId}
                                        update={loadOrderData}
                                    />
                                </IfCond>

                                {
                                    // показыать только в случае прода
                                    !full ? <a href={nextUrl}
                                               onClick={nextPage}
                                               className="btn next-btn">
                                        {_nextText}
                                    </a> : null
                                }
                            </SlidePanel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Suspense>
}

$(() => {
    let appContainer = $('.checkout-app');
    if (appContainer.length > 0) {
        let data = appContainer.data();
        const root = createRoot(appContainer[0]);
        root.render(<CheckoutApp {...data} />);
        window.llg('init_checkout_app', data);
    }
});

export default CheckoutApp;